/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FromMain } from './styles'
import { toast } from 'react-toastify'
import buttonImg from '../../../assets/bgs/Rectangle 9.png'
import Arrow from '../../../assets/icons/ArrowCircleLeft.png'
import { Container } from '../../../styles/GlobalStyles'
import Logo from '../../../assets/logos/imglogo.png'
import { version } from '../../../db/data'
import api from '../../../services/axios'

export default function ForgotPassword() {
  const [nickname, setNickname] = useState('')
  const [loading, setLoading] = useState(false)

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      const response = await api.post('/auth/forgot-password', { nickname })

      if (!response) {
        toast.error('Erro ao enviar o e-mail')
      } else {
        toast.success('Verifique seu e-mail para redefinir a senha!')
      }
    } catch (error) {
      toast.error('Erro na comunicação com o servidor')
    }

    setLoading(false)
  }

  return (
    <Container>
      <FromMain onSubmit={handleForgotPassword} className=''>
        <p className='back-arrow'>
          <Link to='/login' style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={Arrow} alt='voltar' />
            Voltar
          </Link>
        </p>
        <h3>Esqueci minha senha</h3>

        <input
          type='text'
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          placeholder='Digite seu usuário'
          required
        />

        <button type='submit' disabled={loading}>
          <img src={buttonImg} width='100%' alt='Botão entrar' />
          <p className='btn-text'>{loading ? 'Enviando...' : 'Enviar'}</p>
        </button>

        <div className='logo-footer'>
          <img src={Logo} alt='Logo' />
          <span>{version}</span>
        </div>
      </FromMain>
    </Container>
  )
}
